import { RouteLocationNormalized, RouteRecordRaw, START_LOCATION } from 'vue-router'

/** 直アクセスを禁止する */
function denyDirectAccess(to: RouteLocationNormalized, from: RouteLocationNormalized) {
  if (from === START_LOCATION) {
    return { path: '/' }
  }
}

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'index', component: () => import('@/pages/index-page.vue') },
  { path: '/search', name: 'search', component: () => import('@/pages/search-page.vue') },
  { path: '/form', name: 'form', component: () => import('@/pages/form-page.vue') },
  { path: '/confirm', name: 'confirm', component: () => import('@/pages/confirm-page.vue') },
  {
    path: '/completed',
    name: 'completed',
    component: () => import('@/pages/completed-page.vue'),
    beforeEnter: [denyDirectAccess],
  },
]

export default routes
